"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceIssuerAuthorizationEntity = void 0;
class InvoiceIssuerAuthorizationEntity {
    id;
    issuerUserId;
    validFrom;
    validUntil;
    agreementReference;
    acceptanceProcedure;
    revokedAt;
    verifiedBy;
    createdAt;
    updatedAt;
}
exports.InvoiceIssuerAuthorizationEntity = InvoiceIssuerAuthorizationEntity;
